<template>
  <div>Эм, бэлдмэлийн импортын тайлан</div>
</template>
<script>
export default {};
</script>
